// Where each SoftLife surface lives, worked out from the page's own address, so one
// build runs in dev, staging and production with no per-environment URLs baked in.
//
//   env root       dev.playsoftlife.com      playsoftlife.com
//   site           dev.playsoftlife.com      playsoftlife.com
//   play           play.dev.playsoftlife.com play.playsoftlife.com
//   api            api.dev.…                 api.…
//
// An explicit build-time value (VITE_*) wins, for local work and odd hosts. On
// localhost there is nothing to derive, so the caller's fallback applies.
//
// This file is copied into apps/web, apps/admin and apps/partners (each is a
// standalone npm project); keep the copies identical.

export type Surface = "site" | "play" | "api" | "admin" | "admin-api" | "partners" | "payments" | "link";

/** The hostname labels that name a surface (the site has none: it is the env root). */
const LABELS = ["play", "api", "admin", "admin-api", "partners", "payments", "link"];

const IPV4 = /^\d{1,3}(\.\d{1,3}){3}$/;

/** The environment's root domain for a hostname, or null when it can't be derived. */
export function envRoot(hostname: string): string | null {
  const h = hostname.toLowerCase().replace(/\.$/, "");
  if (!h.includes(".") || IPV4.test(h) || h.endsWith(".localhost") || h.endsWith(".local")) return null;
  const [first, ...rest] = h.split(".");
  return LABELS.includes(first) && rest.length >= 2 ? rest.join(".") : h;
}

/** The origin of `surface` in the environment the page is served from. */
export function surfaceUrl(surface: Surface, explicit: string | undefined, fallback: string, loc: Pick<Location, "protocol" | "hostname"> | undefined = globalThis.location): string {
  const set = (explicit ?? "").trim();
  if (set) return set.replace(/\/+$/, "");
  const root = loc ? envRoot(loc.hostname) : null;
  if (!loc || !root) return fallback.replace(/\/+$/, "");
  return `${loc.protocol}//${surface === "site" ? root : surface + "." + root}`;
}
